/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TicketEventStatus = {
    Draft: 'Draft',
    OnSale: 'OnSale',
    Closed: 'Closed'
} as const;
export type TicketEventStatus = typeof TicketEventStatus[keyof typeof TicketEventStatus];


export function instanceOfTicketEventStatus(value: any): boolean {
    for (const key in TicketEventStatus) {
        if (Object.prototype.hasOwnProperty.call(TicketEventStatus, key)) {
            if (TicketEventStatus[key as keyof typeof TicketEventStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TicketEventStatusFromJSON(json: any): TicketEventStatus {
    return TicketEventStatusFromJSONTyped(json, false);
}

export function TicketEventStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketEventStatus {
    return json as TicketEventStatus;
}

export function TicketEventStatusToJSON(value?: TicketEventStatus | null): any {
    return value as any;
}

export function TicketEventStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): TicketEventStatus {
    return value as TicketEventStatus;
}

